module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-36.abed7a6c.svg";